(function() {
$(document).on("click", "#new_organisation_entrant_event_membership .cancel_entrant_event_membership_link", (function(_this) {
  return function(e) {
    var _entrant;
    _entrant = $(e.target).data("entrant");
    $("#add_driver_link_" + _entrant).show();
    return $("#new_entrant_event_membership_" + _entrant).empty();
  };
})(this));

$(document).on("click", ".cancel_remove_entrant_event_membership_link", (function(_this) {
  return function(e) {
    var _membership;
    _membership = $(e.target).data("membership");
    $("#entrant_event_membership_" + _membership + "_show").remove();
    return $("#entrant_event_membership_" + _membership).show();
  };
})(this));

}).call(window);
